export enum AccessLevel {
    View = 0,
    ViewAndEdit = 1,
    None = 2
}